export default "__VITE_ASSET__DmujsIPf__"